import { Component } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';

export let isHK = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Wykorzystajdach.pl';

  isFontS = false;
  isFontN = true;
  isFontL = false;

  constructor(public authService: AuthService,
    private router: Router) {
    this.authService.login();
  }

  isSuperUser(): boolean {
    return this.authService.isSuperUser();
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  getEmail(): string {
    return this.authService.userEmail;
  }

  getIsHK() {
    return isHK;
  }

  switchHK() {
    if (isHK) {
      isHK = false;
    } else {
      isHK = true;
    }
  }

  fontS() {
    this.isFontS = true;
    this.isFontN = false;
    this.isFontL = false;
  }

  fontN() {
    this.isFontS = false;
    this.isFontN = true;
    this.isFontL = false;
  }

  fontL() {
    this.isFontS = false;
    this.isFontN = false;
    this.isFontL = true;
  }

  zaloguj() {
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/app.component.ts